import { state } from "./store";
import { computed } from "vue";
import useVuelidate from '@vuelidate/core';
import { required, email, numeric, alpha, minLength, maxLength, helpers, requiredIf } from '@vuelidate/validators';

export function getStateFormUser() {

    const rules = computed(() => ({
        user: {
            firstname: { required, alpha },
            name: { required, alpha },
            birthday: { required },
            birthplace: { required },
            email: { required, email },
            tel: { required, numeric },
            addressLine1: { required },
            city: { required },
            country: { required },
            zipcode: { required, numeric }
        }
    }));

    const validate = async () => {
        await v$.value.$validate();

        if (!v$.value.$invalid) {
            return true;
        } else {
            return false;
        }
    }

    const v$ = useVuelidate(rules, state);
    return { validate, v1: v$ }
}

export function getStateFormProActivity() {
    const regex = helpers.regex(/^\d{4}[a-zA-Z]$/); // begin with 4 digits and end with one letter

    const rules = computed(() => ({
        activity: {
            isEmployee: { required },
            legalStatus: { required: requiredIf(!state.activity.isEmployee) },
            siret: { required: requiredIf(!state.activity.isEmployee), numeric, maxLength: maxLength(14), minLength: minLength(14) },
            apeCode: { required: requiredIf(!state.activity.isEmployee), regex },
            businessCreation: { required: requiredIf(!state.activity.isEmployee) },
            files: { required }
        }
    }));

    const validate = async () => {
        await v$.value.$validate();

        if (!v$.value.$invalid) {
            return true;
        } else {
            return false;
        }
    }

    const v$ = useVuelidate(rules, state);
    return { validate, v2: v$ }
}

export function getStateFormProFormation() {

    const rules = computed(() => ({
        formation: {
            certification: { required },
            school: { required },
            gotDegrees: { required },
            files: { required }
        }
    }));

    const validate = async () => {
        await v$.value.$validate();

        if (!v$.value.$invalid) {
            return true;
        } else {
            return false;
        }
    }

    const v$ = useVuelidate(rules, state);
    return { validate, v3: v$ }
}

export function getStateFormMotivation() {

    const rules = computed(() => ({
        motivations: { required }
    }));

    const validate = async () => {
        await v$.value.$validate();

        if (!v$.value.$invalid) {
            return true;
        } else {
            return false;
        }
    }

    const v$ = useVuelidate(rules, state);
    return { validate, v4: v$ }
}

export const isError = (vInstance) => vInstance.$invalid && vInstance.$dirty;